import { render } from "./BaseFloatingCard.vue?vue&type=template&id=52a45742&scoped=true"
import script from "./BaseFloatingCard.vue?vue&type=script&lang=js"
export * from "./BaseFloatingCard.vue?vue&type=script&lang=js"

import "./BaseFloatingCard.vue?vue&type=style&index=0&id=52a45742&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52a45742"]])

export default __exports__